import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import {ReactComponent as EmpionLogo} from '../../../../../../../assets/survey_managment/empion_logo_small_white.svg';
import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';

interface HandleNoSurveysProps {
  handleOpen(): void;
}

export default function HandleNoSurveys({handleOpen}: HandleNoSurveysProps) {
  const {t} = useTranslation();

  const handleStartSurvey = () => {
    handleOpen();
  };

  const containerStyles: SxProps = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: {xs: '6px', sm: '12px', md: '16px'},
    marginTop: {xs: '6px', sm: '10px', md: '12px'},
  };

  const handleEmpionLogo = () => {
    return (
      <EmpionLogo
        fill={'white'}
        aria-label='empion logo'
        style={{
          marginRight: '4px',
          marginBottom: '2px',
        }}
      />
    );
  };

  return (
    <Grid container sx={containerStyles}>
      <Typography variant='h4'>{t('companySurveys.details.startSurveyPrompt')}</Typography>
      <EmpionButton onClick={handleStartSurvey}>
        {handleEmpionLogo()}
        <Typography variant='body1'>{t('companySurveys.actionButtons.start')}</Typography>
      </EmpionButton>
    </Grid>
  );
}
